export const LEGAL_STATUS_MAP = {
    legalStatus: 'LEGAL_STATUS',
    legalEvents: 'LEGAL_EVENT',
    simpleLegalStatus: 'SIMPLE_LEGAL_STATUS',
};
export const LEVEL_CODES = ['11', '30'];
